import { render, staticRenderFns } from "./GTabNav.vue?vue&type=template&id=63f17c5b&scoped=true"
import script from "./GTabNav.vue?vue&type=script&lang=js"
export * from "./GTabNav.vue?vue&type=script&lang=js"
import style0 from "./GTabNav.vue?vue&type=style&index=0&id=63f17c5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f17c5b",
  null
  
)

export default component.exports